"use strict";

$(document).ready(function(){
  $('.slick').slick({
    dots: false,
    prevArrow: `<button class="hcar-arrow hcar-arrow-left"></button>`,
    nextArrow: `<button class="hcar-arrow hcar-arrow-right"></button>`
  });
  $('.js-updates').slick({
    arrows: false,
    dots: false,
    draggable: true,
    fade: true,
    speed: 100
  });
  $('.js-update-next').click(function(e) {
    $('.js-updates').slick('slickNext');
    e.preventDefault();
  });
  $('.js-update-prev').click(function(e) {
    $('.js-updates').slick('slickNext');
    e.preventDefault();
  });
  $('iframe[src*="youtube"]').parent().fitVids();
});
